export const aiActionMotion = {
  whileHover: {
    y: -4,
    scale: 1.03,
    transition: {
      type: "spring",
      stiffness: 420,
      damping: 18,
      mass: 0.7,
    },
  },

  whileTap: {
    scale: 0.965,
    y: 1,

    transition: {
      type: "spring",
      stiffness: 520,
      damping: 24,
    },
  },
};

export const utilityMotion = {
  whileHover: {
    scale: 1.018,

    transition: {
      type: "spring",
      stiffness: 360,
      damping: 24,
    },
  },

  whileTap: {
    scale: 0.97,
  },
};

export const navigationMotion = {
  whileHover: {
    x: 4,

    transition: {
      type: "spring",
      stiffness: 300,
      damping: 24,
    },
  },

  whileTap: {
    scale: 0.985,
  },
};

export const destructiveMotion = {
  whileHover: {
    x: -2,
    scale: 1.01,

    transition: {
      type: "spring",
      stiffness: 260,
      damping: 20,
    },
  },

  whileTap: {
    scale: 0.94,
  },
};

export const revealMotion = {
  initial: {
    opacity: 0,
    y: 18,
    scale: 0.985,
  },

  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
  },

  transition: {
    type: "spring",
    stiffness: 120,
    damping: 18,
  },
};

export const cardHoverMotion = {
  whileHover: {
    y: -5,

    transition: {
      type: "spring",
      stiffness: 280,
      damping: 20,
    },
  },
};